import React from 'react';
import { LineChart, BarChart4, Settings, Users } from 'lucide-react';
export const ServicesSection = () => {
  return <section id="services" className="py-16 md:py-24 bg-aspira-white" data-id="element-122">
      <div className="container mx-auto px-4 md:px-6" data-id="element-123">
        <div className="max-w-3xl mx-auto text-center mb-12 md:mb-16" data-id="element-124">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-aspira-navy" data-id="element-125">
            Our Services
          </h2>
          <p className="text-aspira-gray text-lg" data-id="element-126">
            We help businesses achieve a positive growth cycle through our
            comprehensive service offerings.
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-8" data-id="element-127">
          <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100" data-id="element-128">
            <div className="w-14 h-14 bg-aspira-green bg-opacity-10 rounded-full flex items-center justify-center mb-6" data-id="element-129">
              <LineChart className="text-aspira-green" size={28} data-id="element-130" />
            </div>
            <h3 className="text-2xl font-semibold mb-4 text-aspira-navy" data-id="element-131">
              Strategic Growth Consulting
            </h3>
            <p className="text-aspira-gray mb-6" data-id="element-132">
              We identify growth opportunities and develop executable plans to
              maximize your business potential.
            </p>
            <ul className="space-y-3" data-id="element-133">
              <li className="flex items-start" data-id="element-134">
                <div className="bg-aspira-green rounded-full p-1 mr-3 mt-1" data-id="element-135">
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-136">
                    <path d="M20 6L9 17L4 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-137" />
                  </svg>
                </div>
                <span className="text-aspira-gray" data-id="element-138">
                  Market opportunity assessment
                </span>
              </li>
              <li className="flex items-start" data-id="element-139">
                <div className="bg-aspira-green rounded-full p-1 mr-3 mt-1" data-id="element-140">
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-141">
                    <path d="M20 6L9 17L4 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-142" />
                  </svg>
                </div>
                <span className="text-aspira-gray" data-id="element-143">Competitive analysis</span>
              </li>
              <li className="flex items-start" data-id="element-144">
                <div className="bg-aspira-green rounded-full p-1 mr-3 mt-1" data-id="element-145">
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-146">
                    <path d="M20 6L9 17L4 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-147" />
                  </svg>
                </div>
                <span className="text-aspira-gray" data-id="element-148">
                  Growth strategy development
                </span>
              </li>
            </ul>
          </div>
          <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100" data-id="element-149">
            <div className="w-14 h-14 bg-aspira-blue bg-opacity-10 rounded-full flex items-center justify-center mb-6" data-id="element-150">
              <BarChart4 className="text-aspira-blue" size={28} data-id="element-151" />
            </div>
            <h3 className="text-2xl font-semibold mb-4 text-aspira-navy" data-id="element-152">
              CFO Services
            </h3>
            <p className="text-aspira-gray mb-6" data-id="element-153">
              We provide strategic financial planning and analysis to support
              your business growth.
            </p>
            <ul className="space-y-3" data-id="element-154">
              <li className="flex items-start" data-id="element-155">
                <div className="bg-aspira-blue rounded-full p-1 mr-3 mt-1" data-id="element-156">
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-157">
                    <path d="M20 6L9 17L4 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-158" />
                  </svg>
                </div>
                <span className="text-aspira-gray" data-id="element-159">
                  Financial models and projections
                </span>
              </li>
              <li className="flex items-start" data-id="element-160">
                <div className="bg-aspira-blue rounded-full p-1 mr-3 mt-1" data-id="element-161">
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-162">
                    <path d="M20 6L9 17L4 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-163" />
                  </svg>
                </div>
                <span className="text-aspira-gray" data-id="element-164">
                  FP&A, reporting, and dashboards
                </span>
              </li>
              <li className="flex items-start" data-id="element-165">
                <div className="bg-aspira-blue rounded-full p-1 mr-3 mt-1" data-id="element-166">
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-167">
                    <path d="M20 6L9 17L4 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-168" />
                  </svg>
                </div>
                <span className="text-aspira-gray" data-id="element-169">
                  KPIs and performance metrics
                </span>
              </li>
            </ul>
          </div>
          <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100" data-id="element-170">
            <div className="w-14 h-14 bg-aspira-navy bg-opacity-10 rounded-full flex items-center justify-center mb-6" data-id="element-171">
              <Settings className="text-aspira-navy" size={28} data-id="element-172" />
            </div>
            <h3 className="text-2xl font-semibold mb-4 text-aspira-navy" data-id="element-173">
              Operations Optimization
            </h3>
            <p className="text-aspira-gray mb-6" data-id="element-174">
              We streamline your operations to reduce expenses and improve
              efficiency.
            </p>
            <ul className="space-y-3" data-id="element-175">
              <li className="flex items-start" data-id="element-176">
                <div className="bg-aspira-navy rounded-full p-1 mr-3 mt-1" data-id="element-177">
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-178">
                    <path d="M20 6L9 17L4 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-179" />
                  </svg>
                </div>
                <span className="text-aspira-gray" data-id="element-180">Process improvement</span>
              </li>
              <li className="flex items-start" data-id="element-181">
                <div className="bg-aspira-navy rounded-full p-1 mr-3 mt-1" data-id="element-182">
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-183">
                    <path d="M20 6L9 17L4 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-184" />
                  </svg>
                </div>
                <span className="text-aspira-gray" data-id="element-185">
                  Infrastructure development
                </span>
              </li>
              <li className="flex items-start" data-id="element-186">
                <div className="bg-aspira-navy rounded-full p-1 mr-3 mt-1" data-id="element-187">
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-188">
                    <path d="M20 6L9 17L4 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-189" />
                  </svg>
                </div>
                <span className="text-aspira-gray" data-id="element-190">Procedure optimization</span>
              </li>
            </ul>
          </div>
          <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100" data-id="element-191">
            <div className="w-14 h-14 bg-aspira-orange bg-opacity-10 rounded-full flex items-center justify-center mb-6" data-id="element-192">
              <Users className="text-aspira-orange" size={28} data-id="element-193" />
            </div>
            <h3 className="text-2xl font-semibold mb-4 text-aspira-navy" data-id="element-194">
              Strategic Recruiting
            </h3>
            <p className="text-aspira-gray mb-6" data-id="element-195">
              We help you make smart hiring decisions for the long term instead
              of simply putting "butts in seats".
            </p>
            <ul className="space-y-3" data-id="element-196">
              <li className="flex items-start" data-id="element-197">
                <div className="bg-aspira-orange rounded-full p-1 mr-3 mt-1" data-id="element-198">
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-199">
                    <path d="M20 6L9 17L4 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-200" />
                  </svg>
                </div>
                <span className="text-aspira-gray" data-id="element-201">
                  Recruiting process development
                </span>
              </li>
              <li className="flex items-start" data-id="element-202">
                <div className="bg-aspira-orange rounded-full p-1 mr-3 mt-1" data-id="element-203">
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-204">
                    <path d="M20 6L9 17L4 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-205" />
                  </svg>
                </div>
                <span className="text-aspira-gray" data-id="element-206">
                  Screening methodologies
                </span>
              </li>
              <li className="flex items-start" data-id="element-207">
                <div className="bg-aspira-orange rounded-full p-1 mr-3 mt-1" data-id="element-208">
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-209">
                    <path d="M20 6L9 17L4 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-210" />
                  </svg>
                </div>
                <span className="text-aspira-gray" data-id="element-211">
                  Interview process optimization
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
};